import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import UserSettings from '../components/settings/UserSettings';

function Settings() {
  return (
    <Box>
      <Container maxWidth="lg" sx={{ mt: 3, mb: 2 }}>
        <Typography variant="h5" component="h1">
          Gebruikersinstellingen
        </Typography>
      </Container>
      
      <Container maxWidth="lg" sx={{ mt: 3 }}>
        <UserSettings />
      </Container>
    </Box>
  );
}

export default Settings;
